export default "__VITE_ASSET__111c2911__"